
 import React, {FC} from 'react'
 import {Redirect, Switch, Route} from 'react-router-dom'

 import {MasterLayout} from '../../_metronic/layout/MasterLayout'
 import {PrivateRoutes} from './PrivateRoutes'
 import {Logout, AuthPage} from '../modules/auth'

 import AuthService from '../modules/auth/redux/AuthService'
 
  const Routes: FC = () => {

  const usr =  AuthService.GetCurrentUser();
  console.log(":Current User =>>", usr);
  
  const isAuthorized = usr != null ? true:false;

   return (
     <Switch>
       {!isAuthorized ? (
         /*Render auth page when user at `/auth` and not authorized.*/
         <Route>
           <AuthPage />
         </Route>
       ) : (
         /*Otherwise redirect to root page (`/`)*/
         <Redirect from='/auth' to='/' />
       )}
 
       {/* <Route path='/error' component={ErrorsPage} /> */}
       <Route path='/logout' component={Logout} />
 
       {!isAuthorized ? (
         /*Redirect to `/auth` when user is not authorized*/
         <Redirect to='/auth/login' />
       ) : (
         <MasterLayout>
           <PrivateRoutes />
         </MasterLayout>
       )}
     </Switch>
   )
 }
 
 export {Routes}
 